import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const rmaSearch = css`
  :host {
    display: block;
    margin-top: ${csSpacing.spacing08};
  }

  /* cse-paper lays its slotted children out itself, so the gap has to be set on
     the element rather than on this host. */
  .rma-search {
    --cse-paper-row-gap: ${csSpacing.spacing08};
  }

  /* The extra large padding is a desktop measure; on a phone it would eat a
     sixth of the screen. */
  @media(max-width: ${SCREENS.small}) {
    .rma-search {
      --cse-paper-extra-large-padding-x: ${csSpacing.spacing06};
      --cse-paper-extra-large-padding-y: ${csSpacing.spacing06};
    }
  }

  .rma-search__text {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  .rma-search cse-tabs {
    --cse-tab-background-color: transparent;
    --cse-tab-background-color-hover: transparent;
    --cse-tab-panel-background-color: transparent;
    --cse-tab-panel-padding-x: 0;
    --cse-tab-panel-padding-y: 0;
  }

  .rma-search__panel {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
    padding-top: ${csSpacing.spacing08};
  }

  .rma-search__bar {
    display: flex;
    gap: ${csSpacing.spacing06};
    align-items: flex-start;
  }

  .rma-search__input {
    flex: 1 1 auto;
  }

  .rma-search__results {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
  }

  .rma-search__order-title {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: ${csSpacing.spacing04};
  }

  .rma-search__order {
    --cse-accordion-default-content-padding-y: 0;
  }

  .rma-search__order-products {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
    padding-bottom: ${csSpacing.spacing06};
  }
`
